import { useStore } from '@nanostores/react';

import { useUserInfoQuery } from '@/entities/user-info';
import { useCareStateDomain } from '@/entities/care-state-domain';
import { PhrTableTab } from '@/features/phr-table';
import {
  $patientWorkspaceSearchTarget,
  clearPatientWorkspaceSearchTarget,
} from '@/shared/stores/ui';
import { WarningBanner, WorkspaceSection } from '@/shared/ui/primitives';

import { CareStateLabOrdersTable } from './CareStateLabOrdersTable';

interface PatientLabsTabProps {
  userId: string;
}

export function PatientLabsTab({ userId }: PatientLabsTabProps) {
  const userInfoQuery = useUserInfoQuery(userId);
  const insurance = userInfoQuery.data?.patientInfo?.insurance;
  const hasInsurance = insurance !== null && insurance !== undefined && insurance !== '';
  const searchTarget = useStore($patientWorkspaceSearchTarget);
  const openOrderId =
    searchTarget?.resource === 'care-state:lab-orders' ? searchTarget.resultId : undefined;
  const { careState } = useCareStateDomain();
  const hasLabOrders = (careState?.lab_orders?.length ?? 0) > 0;

  return (
    <div className="space-y-6" aria-label="Labs">
      {!hasInsurance && !userInfoQuery.isLoading && (
        <WarningBanner tone="amber">
          This patient does not have insurance information, so labs might not be possible to submit.
        </WarningBanner>
      )}

      {hasLabOrders && (
        <WorkspaceSection title="Ordered Through Lotus Health">
          <CareStateLabOrdersTable
            openOrderId={openOrderId}
            onConsumeOpenOrder={clearPatientWorkspaceSearchTarget}
          />
        </WorkspaceSection>
      )}

      <WorkspaceSection title="EHR Labs">
        <PhrTableTab userId={userId} tableKey="labs" />
      </WorkspaceSection>
    </div>
  );
}
